import { render, staticRenderFns } from "./userDashboardRightList.vue?vue&type=template&id=503c984c&scoped=true"
import script from "./userDashboardRightList.vue?vue&type=script&lang=js"
export * from "./userDashboardRightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c984c",
  null
  
)

export default component.exports